import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimDocument.Save.IRequest;
type Response = Api.Core.ClaimDocument.Save.IResponse;
type Headers = Api.Core.ClaimDocument.Save.IHeaders;
const url = '/api/Claims/Claim/:id/Documents';
export default async function claimDocumentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id: body?.claimId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
